import { reactive } from "vue";

interface EventBus {
    [key: string]: any;
}

const eventBus: EventBus = reactive({});

export default eventBus;